module.exports = __webpack_public_path__ + "static/media/arrangement_banner.04abeb0e.jpg";